import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { AutoCompleteComponent } from './auto-complete.component';
import { AppCheckboxModule } from '../checkbox/checkbox.module';
import { AppDirectiveModule } from 'app/directive/shared-directive.module';

@NgModule({
  imports: [CommonModule, FormsModule, NgxMaskDirective, NgxMaskPipe, AppDirectiveModule, AppCheckboxModule],
  declarations: [AutoCompleteComponent],
  exports: [AutoCompleteComponent, AppDirectiveModule],
})
export class AppAutoCompleteModule {}
